import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Patient } from '../../core/models/patient.model';
import { PatientStateService } from '../../core/services/patient-state.service';

@Component({
  selector: 'app-patient-registration-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule],
  templateUrl: './patient-registration-dialog.component.html',
  styleUrl: './patient-registration-dialog.component.scss'
})
export class PatientRegistrationDialogComponent {
  private readonly patients = inject(PatientStateService);
  private readonly dialogRef = inject(MatDialogRef<PatientRegistrationDialogComponent>);

  readonly patient = this.patients.selectedPatient;

  update(key: keyof Patient, value: string): void {
    this.patients.updateField(this.patient().id, key, value as never);
  }

  close(): void {
    this.dialogRef.close();
  }
}
